import "pixi.js";
import BaseComponent from "./BaseComponent";
import Physics from "./Physics";
import GameSprite from "./GameSprite";
import ProjectileLogic from "./ProjectileLogic";
import C_Snd from "../../const/C_Snd";
import C_Ships from "../../const/C_Ships";
import MathUtil from "../utils/MathUtil";
import FlierData from "../model/FlierData";
import C_GameEvent from "../const/C_GameEvent";

class FlierLogic extends BaseComponent
{


    constructor(flierType)
    {
        super();
        this.app = PIXI.app;
        this.flierType = flierType;
        this.alive = true;
        this.shootQty = 0;
        this.shootCooldown = 0;
        this.isFlyingby = false;
        this.isReturning = false;

        this.scheduleShoot();
    }


    scheduleShoot()
    {
        if (this.shootQty == 0)
        {
            this.timeToShoot = 4 + Math.random()*6;
            this.shootCooldown = 1 + Math.random() * 2;
            this.shootQty = MathUtil.getRandomInt(1,2);
        }
        else
        {
            this.timeToShoot = this.shootCooldown;
            this.shootQty--;
        }
    }


    update(delta)
    {
        let p = this.getEntity().getComponent(Physics);

        if (this.isShooter && p.position.z > 100)
        {
            this.timeToShoot -= delta;

            if (this.timeToShoot <= 0)
            {
                let shootOrigins = FlierData.byType[this.flierType].shootOrigins;
                let numShots = shootOrigins.length;

                this.app.sound.playSound(C_Snd.ENEMY_SHOOT);

                for (let shotIdx = 0; shotIdx < numShots; shotIdx++)
                {
                    let xOffset = shootOrigins[shotIdx].x;
                    let yOffset = shootOrigins[shotIdx].y;

                    let s = this.getEntity().getComponent(GameSprite);
                    s.playMuzzleFlash(xOffset, yOffset);

                    this.scheduleShoot();

                    let p = this.getEntity().getComponent(Physics);
                    let pos = p.position.clone();
                    pos.x += xOffset * p.getSize() * s.aspect / 100;
                    pos.y += yOffset * p.getSize() / 100;

                    let projectile;
                    if (this.shipType == C_Ships.MOTHER_OF_THE_MOONS)
                    {
                        projectile = this.app.eFactory.getMotmProjectile(pos);
                    }
                    else
                    {
                        projectile = this.app.eFactory.getEnemyProjectile(pos, p.velocity.getLength());
                    }
                    this.app.eSys.addEntity(projectile);
                }


            }
        }

        if (FlierData.byType[this.flierType].canReturn && p.position.z < 500 && !this.isReturning)
        {
            this.isReturning = true;
            TweenMax.delayedCall(2, this.returnBack.bind(this), [p]);
            p.stopMove = true;
            p.changeZVelocity(p.velocity.z*(-1));
        }


        let distance = Math.sqrt(Math.pow(p.position.x - p.position.x/2, 2) +
            Math.pow(p.position.y - p.position.y/10, 2) +
            Math.pow(p.position.z, 2));
        if (this.shipType == C_Ships.ENEMY_SHIP && distance < 100 && !this.isFlyingby)
        {
            this.isFlyingby = true;

            let triggerRadius = p.position.x*p.position.x + p.position.y*p.position.y;
            if (triggerRadius < 1000)
            {
                let velocityZ = Math.abs(p.velocity.z);
                // console.log("fly by");
                // console.log(this.flierType);
                // console.log(p.position.z);
                // console.log(p.position.x*p.position.x + p.position.y*p.position.y);

                let volume = 0.5*(p.position.z/100); // the less the distance for X and Y from 0, the higher Z will be, and the higher the volume

                if (velocityZ > 50)
                {
                    this.app.sound.playSound(C_Snd.FLY_BY_SPACECRAFT_2, volume);
                }
                else if (velocityZ > 30)
                {
                    this.app.sound.playSound(C_Snd.FLY_BY_SPACECRAFT_3, volume);
                }
                else if (velocityZ > 20)
                {
                    this.app.sound.playSound(C_Snd.FLY_BY_SPACECRAFT_4, volume);
                }
                else
                {
                    this.app.sound.playSound(C_Snd.FLY_BY_SPACECRAFT_5, volume);
                }
            }
        }
    }


    returnBack(p)
    {
        p.stopMove = false;
    }


    getFlierType()
    {
        return this.flierType;
    }


    getFlierServerId()
    {
        return FlierData.byType[this.flierType].serverId;
    }


    postPhysicsUpdate(delta)
    {
        let p = this.getEntity().getComponent(Physics);

        for (let colIdx = 0; colIdx<p.collisions.length; colIdx++)
        {
            let collidingEntity = p.collisions[colIdx];
            let projLogic = collidingEntity.getComponent(ProjectileLogic);

            if (projLogic)
            {
                let s = this.getEntity().getComponent(GameSprite);
                this.app.sound.playSound(C_Snd.SHIELD_HIT);
                s.playDamageAnim();
            }
        }

        p.collisions.length = 0;
    }


    // killedBy - 0 is the player, 1 is left bot, 2 is right bot
    kill(killAll = false, killedBy = 0)
    {
        if (this.alive)
        {
            this.alive = false;

            this.app.sound.playSound(C_Snd.DESTROY[this.shipType], .3);

            let s = this.getEntity().getComponent(GameSprite);
            if (s.hasGoo())
            {
                // let p = this.getEntity().getComponent(Physics);
                // p.setVelocity(0, 0, 0);
                // this.entitySystem.physicsSys.remove(p);

                s.playGooKillAnim();
                TweenMax.delayedCall(.5, this.finishKill, [false, killedBy], this);
            }
            else
            {
                s.playDamageAnim();
                s.playDeathAnim(!killAll);
                TweenMax.delayedCall(.5, this.finishKill, [], this);
            }
        }
    }


    finishKill(killSprite = true, killedBy)
    {
        if (!killSprite)
        {
            // this.app.dispatcher.emit(C_GameEvent.RESCUE_POD_GOO_CLEAN, s.sprite);
            this.app.dispatcher.emit(C_GameEvent.RESCUE_POD_GOO_CLEAN, this.getEntity(), killedBy);
        }
        this.getEntity().queueForRemoval = true;
    }


    isAlive()
    {
        return this.alive;
    }


    destroy()
    {
        this.alive = false;
    }


}


export default FlierLogic;